import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import {Program, Site} from '../domain/cloud-topology';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private sites: BehaviorSubject<Site[]>;
  private programs: BehaviorSubject<Program[]>;
  constructor() {
    this.clear();
  }

  setSites(sites: Site[]) {
    this.sites.next(sites);
  }

  getSites(): Observable<Site[]> {
    return this.sites.asObservable();
  }

  setPrograms(programs: Program[]): void {
    this.programs.next(programs);
  }

  getPrograms(): Observable<Program[]> {
    return this.programs.asObservable();
  }

  clear() {
    this.sites = new BehaviorSubject<Site[]>(null);
    this.programs = new BehaviorSubject<Program[]>(null);
  }
}
